import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Field } from "formik";

export default function Address(props) {

	function getAddress(address) {
		if(address) {
			return `ZNG ${address.ServiceId} | ${address.StreetAddress}, ${address.MDUName ? address.MDUName + ", " : ""}${address.MDUBlock ? "BLOCK " + address.MDUBlock + ", " : ""}${address.MDUUnitNumber ? "UNIT " + address.MDUUnitNumber + ", " : ""}${address.Township} | ${address.ERF}`;
		}
	}

	return 	<React.Fragment>
					{props.address ?
						<Form.Group as={Row} className="mb-3">
						<Form.Label column sm={4}>Address</Form.Label>
						<Col sm={8}>
							{/* <input readOnly className="form-control bg-light" value={ props && props.address ? getAddress(props.address) : "" }></input> */}
							<Field as={Form.Control} value={ props && props.address ? getAddress(props.address) : "" } className="mb-3 bg-light" readOnly disabled></Field>
						</Col>
					</Form.Group> :
					<Form.Group as={Row} className="mb-3">
						<Form.Label column sm={4}>What is your address?</Form.Label>
						<Col sm={8}>
							<Field readOnly={props.disabled} isInvalid={props.errors?.PotentialAddress && props.touched?.PotentialAddress } as={Form.Control} name="PotentialAddress"></Field>
							<small className="text-danger">{ props.touched?.PotentialAddress && props.errors?.PotentialAddress }</small>
						</Col>						
					</Form.Group>
					}
					<Form.Group as={Row} className="mb-3 d-none">
						<Form.Label column sm={4}>City</Form.Label>
						<Col sm={8}><input readOnly className="form-control" value={ props?.address?.Township }></input></Col>
					</Form.Group>
					<Form.Group as={Row} className="mb-3 d-none">
						<Form.Label column sm={4}>Zip</Form.Label>
						<Col sm={8}><input readOnly className="form-control" value={ props?.address?.Zip }></input></Col>
					</Form.Group>
					<Form.Group as={Row} className="mb-3 d-none">
						<Form.Label column sm={4}>Country</Form.Label>
						<Col sm={8}><input readOnly className="form-control" value={ props?.address?.Country }></input></Col>
					</Form.Group>
				</React.Fragment>
}